export const GET_APP_ROLES = "GET_APP_ROLES";
export const SET_APP_ROLES = "SET_APP_ROLES";

export const GET_ROLE = "GET_ROLE";
export const SET_ROLE = "SET_ROLE";

export const REMOVE_APP_ROLE = "REMOVE_APP_ROLE";
export const SET_REMOVE_APP_ROLE = "SET_REMOVE_APP_ROLE";

export const CREATE_APP_ROLE = "CREATE_APP_ROLE";
export const SET_CREATE_APP_ROLE = "SET_CREATE_APP_ROLE";

export const UPDATE_APP_ROLE = "UPDATE_APP_ROLE";
export const SET_UPDATE_APP_ROLE = "SET_UPDATE_APP_ROLE";

export const GET_CHECK_ROLE = "GET_CHECK_ROLE";
export const SET_CHECK_ROLE = "SET_CHECK_ROLE";
export const SET_IS_CHECK_ROLE = "SET_IS_CHECK_ROLE";

export const SET_IS_CHECK = "SET_IS_CHECK"
